// extracted by mini-css-extract-plugin
export var childrenContainer = "_3p-0";
export var virtualScrollArea = "_3p-1";